exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.indent-update-dialog {\n    position: fixed;\n    right: 0;\n}\n", "", {"version":3,"sources":["/var/lib/jenkins/workspace/tms-docker-build/frontend/shipper/src/modules-v2/indent/views/create-update/index.vue"],"names":[],"mappings":";AACA;IACI,gBAAgB;IAChB,SAAS;CACZ","file":"index.vue","sourcesContent":["\n.indent-update-dialog {\n    position: fixed;\n    right: 0;\n}\n"],"sourceRoot":""}]);

// exports
